// Lib
import { FC } from "react";
// Types
import {
  CustomerMenuAddonModifier,
  CustomerMenuProduct,
} from "types/customers";
import { AddonsModifiers } from "pages/Orders/View/OrderCreate/types";
// Components
import { Checkbox } from "components/Form";
import { CheckBoxLabel } from "../../../CheckBoxLabel";
// Styled
import { FlexContainer } from "styled/Box";

interface ModifiersProps {
  selectedProduct: CustomerMenuProduct | null;
  selectedModifiers: AddonsModifiers;
  onCheck: (addonModifier: CustomerMenuAddonModifier, value: boolean) => void;
}

export const Modifiers: FC<ModifiersProps> = ({
  selectedProduct,
  selectedModifiers,
  onCheck,
}) => {
  if (!selectedProduct?.modifiers) {
    return null;
  }

  return (
    <>
      {selectedProduct.modifiers.map(el => (
        <FlexContainer
          key={el.id}
          $fullwidth
          $justify="space-between"
          $align="center"
          $margin="0 0 4px 0"
        >
          <Checkbox
            checked={!!selectedModifiers.modifier.find(m => m.id === el.id)}
            label={<CheckBoxLabel label={el.name} />}
            onChange={e => onCheck(el, e.target.checked)}
          />
        </FlexContainer>
      ))}
    </>
  );
};
